import * as React from 'react';

import { ReactComponent as SecureLockIcon } from 'assets/icons/secure-lock.svg';
import { Title, Details, CancellationPolicy, Strong } from './styles';
import { Customization, WhenCustomization } from 'components/WhenCustomization';

export type ProductType =
  | 'REGULAR_APPOINTMENT'
  | 'REQUIRES_IMMEDIATE_PAYMENT'
  | 'GYN_APPOINTMENT'
  | 'RESCHEDULE_APPOINTMENT';

type Props = {
  productType: ProductType;
  showCancellationPolicy: () => void;
};

const PaymentDetails = (props: Props) => {
  const { productType, showCancellationPolicy } = props;

  return (
    <>
      <Title>
        {productType === 'RESCHEDULE_APPOINTMENT'
          ? 'Confirm your new appointment time'
          : 'Payment details'}{' '}
        <SecureLockIcon />{' '}
      </Title>
      <Details>
        {['GYN_APPOINTMENT', 'REGULAR_APPOINTMENT'].includes(productType) && (
          <>
            We’ll need a credit card to hold this appointment for you.{' '}
            <Strong>
              You will not be charged until the time of your appointment, and we will bill your
              insurance if you have it, subject to your co-pay and/or co-insurance.{' '}
            </Strong>
          </>
        )}

        <WhenCustomization is={Customization.NONE}>
          If you are unable to make your appointment, be sure to cancel within the designated
          timeframe as stipulated in our{' '}
          <CancellationPolicy onClick={showCancellationPolicy}>
            cancellation policy.
          </CancellationPolicy>
        </WhenCustomization>

        <WhenCustomization is={Customization.DISNEY}>
          If you are unable to make it to your appointment, please make sure to cancel or reschedule
          ahead of time.
        </WhenCustomization>
      </Details>
    </>
  );
};

export default PaymentDetails;
